import { useState } from 'react';

export const useColectivos = () => {
  const [colectivos, setColectivos] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);

  const getLinea = (descripcionLinea) => {
    if (descripcionLinea) {
      const parts = descripcionLinea.split(" ");
      return parts.length > 1 ? parts[1] : descripcionLinea;
    }
    return '';
  }

  const obtenerColectivos = async (endpoint, method = 'GET', body = null) => {
    setCargando(true);
    setError(null);
    try {
      const options = {
        method: method
      };

      if (body && method === 'POST') {
        options.headers = {
          'Content-Type': 'application/json'
        };
        options.body = JSON.stringify(body);
      }

      const response = await fetch(endpoint, options);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const text = await response.text();
      console.log('Raw response:', text);
      
      let data;
      try {
        data = JSON.parse(text);
      } catch (parseError) {
        console.error('Response is not valid JSON:', text);
        setError(`Respuesta inválida de API: ${text}`);
        setColectivos([]);
        return;
      }

      console.log('Parsed data:', data, 'Type:', typeof data, 'Is Array:', Array.isArray(data));

      if (data !== undefined && data !== null && Array.isArray(data)) {
        setColectivos(data);
      } else if (data !== undefined && data !== null && typeof data === 'object') {
        // Si es un objeto, intenta extraer un array de sus propiedades
        const arrayData = Object.values(data).find(val => Array.isArray(val));
        if (arrayData) {
          console.log('Array encontrado en propiedades del objeto:', arrayData);
          // Transformar datos a la estructura esperada por el componente
          const transformedData = arrayData.map(item => ({
            id: item.codigoLinea || item.id,
            linea: getLinea(item.descripcionLinea),
            destino: item.descripcionBandera || item.destino,
            descripcionLinea: item.codigoLinea || item.descripcionLinea,
            tiempo: item.tiempoRestanteArribo || item.tiempo
          }));
          console.log('Transformed data:', transformedData);
          setColectivos(transformedData);
        } else {
          console.warn('Data no es un array ni contiene arrays:', data);
          setColectivos([]);
        }
      } else {
        console.warn('Data inesperada:', data);
        setColectivos([]);
      }
      
    } catch (error) {
      console.error('Error al obtener datos:', error);
      setError(error?.message || 'Error al cargar los datos');
      setColectivos([]);
    } finally {
      setCargando(false);
    }
  };

  return { colectivos, cargando, error, obtenerColectivos };
};
